exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-image {\n  width: 120px;\n  height: 70px;\n}\n.viewbigImg {\n  position: relative;\n  top: -8px;\n  left: 20px;\n}\n.checkitemcheck {\n  margin-left: -110px !important;\n}\n", ""]);

// exports
